import React, { useEffect } from 'react'
import { useThemeAccent } from '@/contexts/ThemeAccentContext'
import { resolveAccentMain } from '@/theme/accentPresets'
import uniStar from '@/assets/uni-star.png'

export type AppFaviconLoai = 'bh' | 'kho'

/** Icon nhà kho (port favicon kho-frontend) — nền + chi tiết tô theo màu theme. */
const khoFaviconSvg = (mau: string): string =>
  `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32">` +
  `<rect width="32" height="32" rx="7" fill="${mau}"/>` +
  `<path fill="#ffffff" d="M6 15.2 16 9l10 6.2V24H6z"/>` +
  `<rect x="11" y="18" width="4.5" height="6" rx=".5" fill="${mau}"/>` +
  `<rect x="16.5" y="18" width="4.5" height="6" rx=".5" fill="${mau}"/>` +
  `<path fill="#ffffff" d="M21.5 19.5h5.5v5.5h-5.5z"/>` +
  `<path fill="${mau}" d="M22.8 21.2h2.9v1.1h-2.9zm0 2.2h2.9v1.1h-2.9z"/>` +
  `</svg>`

let loaiHienTai: AppFaviconLoai = 'bh'
let mauTheme = '#2563eb'

const render = (): void => {
  if (typeof document === 'undefined') return
  const laKho = loaiHienTai === 'kho'
  const href = laKho ? `data:image/svg+xml,${encodeURIComponent(khoFaviconSvg(mauTheme))}` : uniStar

  let link = document.querySelector("link[rel='icon']") as HTMLLinkElement | null
  if (!link) {
    link = document.createElement('link')
    link.rel = 'icon'
    document.head.appendChild(link)
  }
  if (link.getAttribute('href') === href) return
  link.type = laKho ? 'image/svg+xml' : 'image/png'
  link.href = href
  link.sizes.add('32x32')
}

/** Favicon tab: `bh` = bán hàng (mặc định), `kho` = các màn menu Kho (màu theo theme). */
export function applyAppFavicon(loai: AppFaviconLoai = 'bh'): void {
  loaiHienTai = loai
  render()
}

const ThemeFaviconUpdater: React.FC = () => {
  const { accentId } = useThemeAccent()
  const primaryMain = resolveAccentMain(accentId)

  useEffect(() => {
    mauTheme = primaryMain
    render()
    if (typeof document === 'undefined') return
    const meta = document.querySelector('meta[name="theme-color"]') as HTMLMetaElement | null
    if (meta) meta.content = primaryMain
  }, [primaryMain])

  return null
}

export default ThemeFaviconUpdater
